module.exports = __webpack_public_path__ + "media/coffee-preferences/acidity_high-b5d6e9e5.png";